import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function IndexBlock(props) {
  const className = `${style.block} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

IndexBlock.propTypes = {
  /**
   * Child components to render on Index Block
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  /**
   * className
   */
  className: PropTypes.string,
};

IndexBlock.defaultProps = {
  className: '',
};
